<!-- DESC：负责发邮件给论文作者 -->
<template>
    <div class="authoremail-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Email to Authors</div>
                    <br />
                    <div class="info">
                        Using this page, you can send email to authors
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 邮件内容构建 -->
        <el-row>
            <el-col :span="15">
                <div class="email-box">
                    <!-- 标题 -->
                    <div
                        style="margin-bottom:30px;border-left: 3px solid rgba(48, 132, 158, 0.575);padding-left: 10px;">
                        Email</div>
                    <el-card shadow="always">
                        <el-form :model="emailform" label-width="91px">
                            <el-form-item label="Subject:" required>
                                <el-input v-model="emailform.subject" />
                            </el-form-item>
                            <el-form-item label="Message:" required>
                                <el-input v-model="emailform.message" type="textarea" :rows="8"
                                    :autosize="{ minRows: 8, maxRows: 20 }" resize="none" />
                                <div style="margin-top:5px">
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${id}, we will match you with the paper's id"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${id}')">${id}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${autoid}, we will match you with the paper's assigned id"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${autoid}')">${autoid}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${title}, we will match you with the paper's title"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${title}')">${title}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${firstname}, we will match you with the author's firstname"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${firstname}')">${firstname}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${lastname}, we will match you with the author's lastname"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${lastname}')">${lastname}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${authorlist}, we will match you with the author's authorlist"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${authorlist}')">${authorlist}</el-tag>
                                    </el-tooltip>
                                </div>
                            </el-form-item>
                            <el-upload ref="uploadRef" class="upload-demo" :auto-upload="false" :limit="1"
                                :on-exceed="handleExceed" :http-request="sendemail" v-model:file-list="fileList">
                                <template #trigger>
                                    <el-text class="mx-1"
                                        style="margin-right: 10px;">Attachment:</el-text><el-button>select
                                        file</el-button>
                                </template>
                            </el-upload>
                            <el-form-item>
                                <el-checkbox v-model="emailform.isAllCorresponding"
                                    label="Send to all authors of selected papers (not only corresponding ones)"
                                    name="type" />
                            </el-form-item>
                        </el-form>
                        <el-divider border-style="dashed" />
                        <div style="display: flex;justify-content: center;" @click="presend"><el-button
                                type="primary">Send
                                Email</el-button>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <!-- 标题 -->
                <div style="margin:30px 0;border-left: 3px solid rgba(48, 132, 158, 0.575);padding-left: 10px;">
                    Submissions
                </div>
                <!-- 列表 -->
                <div class="paperlist-box">
                    <el-card shadow="always">
                        <el-table :data="conferencePaperList" style="width: 100%" border class="tb-box"
                            ref="multipleTableRef" @selection-change="handleSelectionChange" v-loading="loading"
                            element-loading-text="Loading..." :element-loading-spinner="svg"
                            element-loading-svg-view-box="-10, -10, 50, 50" @sort-change="sortTable">
                            <el-table-column type="selection" width="55" align="center" />
                            <el-table-column label="Submission" header-align="center">
                                <template #default="scope">
                                    <el-text type="primary" class="title-text" size="small">{{ scope.row.autoid
                                        }}.{{ scope.row.authors }}/{{ scope.row.title }}</el-text>
                                </template>
                            </el-table-column>
                            <el-table-column label="Decision" align="center" header-align="center" width="100"
                                :filters="[{ text: 'ACCEPT', value: 'ACCEPT' }, { text: 'REJECT', value: 'REJECT' }, { text: 'UNKNOW', value: 'UNKNOW' }]"
                                :filter-method="filterTag">
                                <template #default="scope">
                                    <el-tag type="danger" class="title-text"
                                        v-if="scope.row.isTermination == 1">REJECT</el-tag>
                                    <el-tag type="success" class="title-text"
                                        v-else-if="scope.row.status == 4 && scope.row.isTermination != 1">ACCEPT</el-tag>
                                    <span class="title-text" v-else></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="UpdateTime" align="center" width="160" sortable="custom"
                                header-align="center">
                                <template #default="scope">
                                    <el-text class="title-text" size="small">{{ scope.row.updatetime }}</el-text>
                                </template>
                            </el-table-column>
                            <el-table-column label="operate" width="240" align="center">
                                <template #header>
                                    <el-input v-model="searchValue" size="small" placeholder="enter search content"
                                        @input="changeSearchValue" :suffix-icon="Search" />
                                </template>
                                <template #default="scope">
                                    <el-button size="small" @click="look(scope.$index, scope.row)" type="danger"
                                        :icon="View">information</el-button>
                                    <el-button size="small" @click="download(scope.$index, scope.row)" type="warning"
                                        :icon="Document" style="width: 90px;">paper file</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import request from "../../network/request"
import { useRoute } from "vue-router"
import { ElMessage } from 'element-plus'
import { View, Document,ArrowLeftBold } from '@element-plus/icons'
import { ElLoading } from 'element-plus'
import { dataBox } from 'js-tool-big-box';

const route = useRoute()

// 加载条
const loading = ref(true)
// 排序规则
const sortRule = ref("autoid asc")
// 文件列表
const fileList = ref([])
// 邮件表单信息
const emailform = ref({ subject: "", message: "", isAllCorresponding: false })
const emailList = ref([])
// 上传文件对象
const uploadRef = ref()
// 搜索值
const searchValue = ref("")
// 上传文件覆盖
const handleExceed = (files) => {
    uploadRef.value.clearFiles()
    const file = files[0]
    file.uid = 0
    uploadRef.value.handleStart(file)
}
// 会议投稿论文
const conferencePaperList = ref([])
// 选中的论文
const multipleTableRef = ref()
const multipleSelection = ref([])
const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>`


// 表格选择列表修改
const handleSelectionChange = (val) => {
    multipleSelection.value = val
    console.log(emailform.value.isAllCorresponding);
}

// 获取会议投稿论文列表
function getConferencePaperList() {
    request.get(`/conference/paperlist?pagenum=1&pagesize=99999&cid=${route.query.cid}&sortRule=${sortRule.value}&keyword=${searchValue.value}`).then((res) => {
        conferencePaperList.value = []
        let datalist = res.data.list;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            conferencePaperList.value.push({ id: item.id, pid: item.pid, authors: authornames, title: title, status: item.status, paperfile: item.paperfile, isTermination: item.isTermination, updatetime: item.updatetime, emailaddre: item.emailaddre, authorList: item.authorList, autoid: item.autoid })
            loading.value = false
        })
    })
}

// 搜索值改变，修改后端
const changeSearchValue = (payload) => {
    setTimeout(() => {
        getConferencePaperList()
    }, 500);
}

// 查看论文详细信息
const look = (index, row) => {
    window.open(`#/common/detailpaper?pid=${row.pid}&role=3&acronym=${route.query.acronym}`, '_blank');
}

//下载PDF
const download = (index, payload) => {
    let acronym = route.query.acronym.split(" ").join("_")
    let autoid = payload.autoid
    saveAs(payload.paperfile, `${acronym}_paper_${autoid}.pdf`)
}


// 筛选表格
const filterTag = (value, row) => {
    multipleTableRef.value.clearSelection()
    // 筛选录用
    if (value == "ACCEPT") {
        return row.status == 4 && row.isTermination != 1
    }
    // 筛选拒稿
    else if (value == "REJECT") {
        return row.isTermination == 1
    }
    else {
        return row.status <= 3 && row.isTermination != 1
    }
}

// 发送预处理
const presend = () => {
    // 空值效验
    if (!emailform.value.subject) {
        ElMessage({
            message: `subject cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (!emailform.value.message) {
        ElMessage({
            message: `message cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (multipleSelection.value.length == 0) {
        ElMessage({
            message: `emaillist cannot be empty`,
            type: 'warning',
        })
        return
    }
    // 构建邮件列表
    emailList.value = []
    if (emailform.value.isAllCorresponding) {
        multipleSelection.value.forEach((item) => {
            item.authorList.forEach((author) => {
                emailList.value.push(author.email)
            })
        })
    }
    else {
        multipleSelection.value.forEach((item) => {
            item.authorList.forEach((author) => {
                if (author.isCorresponding == 1) {
                    emailList.value.push(author.email)
                }
            })
        })
    }
    // 空文件后端传值
    if (fileList.value.length == 0) {
        let data = {
            subject: emailform.value.subject,
            message: emailform.value.message,
            emailList: [...new Set(emailList.value.filter(email => email.trim() !== ""))].join(","),
            paperList: multipleSelection.value.map(item => item.pid),
            isall: emailform.value.isAllCorresponding
        }
        const loading = ElLoading.service({
            // 加载进度条
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
        request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                ElMessage({
                    message: 'the email has been sent',
                    type: 'success',
                })
                loading.close()
            } else {
                ElMessage({
                    message: 'the email sending failed',
                    type: 'warning',
                })
                loading.close()
            }
        })
    }
    else {
        uploadRef.value.submit()
    }


}

// 附件形式发送邮件
const sendemail = (payload) => {
    let data = {
        subject: emailform.value.subject,
        message: emailform.value.message,
        emailList: [...new Set(emailList.value.filter(email => email.trim() !== ""))].join(","),
        paperList: multipleSelection.value.map(item => item.pid),
        file: payload.file,
        isall: emailform.value.isAllCorresponding
    }
    const loading = ElLoading.service({
        // 加载进度条
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    })
    request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'the email has been sent',
                type: 'success',
            })
            loading.close()
        } else {
            ElMessage({
                message: 'the email sending failed',
                type: 'warning',
            })
            loading.close()
        }
    })
}

// 获取排序列和排序规则，交由后端负责排序
const sortTable = (payload) => {
    if (payload.column.order == "ascending") {
        sortRule.value = payload.column.label.toLowerCase() + " " + payload.column.order.substring(0, 3)
        getConferencePaperList()
    }
    else if (payload.column.order == "descending") {
        sortRule.value = payload.column.label.toLowerCase() + " " + payload.column.order.substring(0, 4)
        getConferencePaperList()
    }
    else {
        sortRule.value = "autoid desc"
        getConferencePaperList()
    }
}

// 快捷复制信息
const copyinfo = (text) => {
    dataBox.copyText(text, () => {
        ElMessage({
            type: 'success',
            message: '复制成功'
        })
    })
}

onMounted(() => {
    // 获取会议投稿论文列表
    getConferencePaperList()
})

</script>

<style lang="scss">
.authoremail-box {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

}
</style>